/** *
 * To add more static widgets:
 *  - Implement the StaticComponent in the react-pkg package
 *  - Add the css to the viewer/static-components.scss file
 *  - Add the widget to the is-static-widget.ts file in the utils package
 */

const STATIC_NODES = new Set(['section', 'frame', 'image', 'text', 'shape']);

export function isStaticWidget(type: string) {
  return STATIC_NODES.has(type);
}
